import { adConfigReceived, adConfigUnloaded } from 'redux-implementations/googleAds';
import { useDispatch } from 'react-redux';

import config from 'lib/config';
import { useRouter } from 'next/router';
import { useDeepCompareEffect } from 'react-use';
import { Targeting } from '../GoogleAds';

function testAdsDesired(queryParamValue?: string | string[]): boolean {
  return config.testAds || queryParamValue === 'jumpstart';
}

const DISABLE_ADS_PARAM = 'disableAds';
const TEST_ADS_PARAM = 'test';

export default function useAdSetup(adUnit: string, targeting: Targeting): void {
  const dispatch = useDispatch();
  const { query, locale } = useRouter();
  const queryFromBrowser =
    typeof window !== 'undefined'
      ? Object.fromEntries(new URLSearchParams(window.location.search))
      : {};
  const adsDisabledParam = query[DISABLE_ADS_PARAM] || queryFromBrowser[DISABLE_ADS_PARAM];
  const testAdsParam = query[TEST_ADS_PARAM] || queryFromBrowser[TEST_ADS_PARAM];

  useDeepCompareEffect(() => {
    dispatch(
      adConfigReceived({
        adsDisabled: adsDisabledParam === 'true',
        adTargeting: {
          test: testAdsDesired(testAdsParam) ? 'jumpstart' : undefined,
          browserlanguage: locale,
          pub: 'ALST',
          ...targeting,
        },
        adUnit,
      })
    );

    return (): void => {
      dispatch(adConfigUnloaded());
    };
  }, [adUnit, adsDisabledParam, dispatch, targeting, testAdsParam]);
}
